import { Link } from 'react-router-dom';
import { categories, mangas } from '@/mocks/manga';
import { SITE_NAME, CONTACT_INFO } from '@/utils/site';

export default function Footer() {
  const hotMangas = mangas.filter((m) => m.isHot).slice(0, 5);

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 md:px-6 md:pt-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-xl md:text-2xl">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-book-2-fill" aria-hidden="true" />
              </span>
              <span className="font-heading">
                073<span className="text-primary-400">漫画网</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              {SITE_NAME}是专注健身题材的热门漫画免费阅读平台，《健身教练》等精彩作品支持下拉式流畅阅读，每日稳定更新，看漫画免费阅读就到073漫画网。
            </p>
            <div className="mt-4 flex items-center gap-3 text-background-200">
              <a
                href="#!"
                aria-label="微信公众号"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-primary-500"
              >
                <i className="ri-wechat-fill" aria-hidden="true" />
              </a>
              <a
                href="#!"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-primary-500"
              >
                <i className="ri-weibo-fill" aria-hidden="true" />
              </a>
              <a
                href="#!"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-primary-500"
              >
                <i className="ri-bilibili-fill" aria-hidden="true" />
              </a>
            </div>
          </div>

          <nav aria-label="网站导航">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-background-50">快捷导航</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              <li>
                <Link to="/" className="transition-colors hover:text-primary-300">
                  网站首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="transition-colors hover:text-primary-300">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/manga/m1" className="transition-colors hover:text-primary-300">
                  《健身教练》漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="transition-colors hover:text-primary-300">
                  联系我们
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="漫画分类">
            <h2 className="text-sm font-semibold uppercase tracking-wider text-background-50">漫画分类</h2>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm text-background-200/80">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="transition-colors hover:text-primary-300">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="text-sm font-semibold uppercase tracking-wider text-background-50">热门漫画</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200/80">
              {hotMangas.map((m) => (
                <li key={m.id}>
                  <Link to={`/manga/${m.id}`} className="transition-colors hover:text-primary-300">
                    《{m.title}》
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-50/10 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex flex-col gap-1 sm:flex-row sm:flex-wrap sm:items-center sm:gap-3">
            <span>© 2023-2026 {SITE_NAME} 版权所有</span>
            <span className="hidden sm:inline">|</span>
            <span className="flex items-center gap-1">
              <i className="ri-mail-line" aria-hidden="true" />
              {CONTACT_INFO.email}
            </span>
          </div>
          <p className="max-w-xl leading-relaxed">
            免责声明：本站漫画内容均由用户上传或网络采集，仅供学习交流使用，请于下载后24小时内删除。如侵犯您的权益，请与我们联系。
          </p>
        </div>
      </div>
    </footer>
  );
}